"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionModelToJSON = exports.PositionModelFromJSONTyped = exports.PositionModelFromJSON = void 0;
function PositionModelFromJSON(json) {
    return PositionModelFromJSONTyped(json, false);
}
exports.PositionModelFromJSON = PositionModelFromJSON;
function PositionModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'x1': json['x1'],
        'y1': json['y1'],
        'x2': json['x2'],
        'y2': json['y2'],
        'x3': json['x3'],
        'y3': json['y3'],
        'x4': json['x4'],
        'y4': json['y4'],
    };
}
exports.PositionModelFromJSONTyped = PositionModelFromJSONTyped;
function PositionModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'x1': value.x1,
        'y1': value.y1,
        'x2': value.x2,
        'y2': value.y2,
        'x3': value.x3,
        'y3': value.y3,
        'x4': value.x4,
        'y4': value.y4,
    };
}
exports.PositionModelToJSON = PositionModelToJSON;
//# sourceMappingURL=PositionModel.js.map